import { Component } from '@angular/core';
import { Dotcom2024Service } from '../dotcom2024.service';
import { environment } from '../../environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { Meta, Title } from '@angular/platform-browser';
import { MyharrellsService } from '../myharrells.service';

@Component({
  selector: 'app-contacts',
  standalone: true,
  imports: [CommonModule, FormsModule, GoogleMapsModule],
  templateUrl: './contacts.component.html',
  styleUrl: './contacts.component.css'
})
export class ContactsComponent {
  constructor(public myHarrellsService: MyharrellsService, private title: Title, private meta: Meta, public dotComService: Dotcom2024Service) { }

  options: google.maps.MapOptions = {
    mapId: "DEMO_MAP_ID",
    center: { lat: -31, lng: 147 },
    zoom: 4,
  };

  nzLocations: any[] = [];

  // warehouses: any[] = [];
  // corpOffice: any = {};
  warehouseToDisplay: number = 0;

  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Locations/";
  employeePhotosImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Employee-Photos/";

  ngOnInit(): void {

    


    //meta tags for SEO
    this.title.setTitle("Contact Harrell’s | Corporate & Warehouse Information");
    this.meta.updateTag({ name: 'description', content: "Find contact details for Harrell’s corporate office, warehouses, HR, and credit department. Reach out for agronomic solutions and customer support." });
    this.meta.updateTag({ property: 'og:title', content: "Contact Harrell’s | Corporate & Warehouse Information" });
    this.meta.updateTag({ property: 'og:description', content: "Find contact details for Harrell’s corporate office, warehouses, HR, and credit department. Reach out for agronomic solutions and customer support." });
    // this.meta.updateTag({ property: 'og:image', content: "og:image here - contacts" });
    // this.meta.updateTag({ property: 'og:url', content: "og:url here - contacts" });
    this.meta.updateTag({ property: 'Twitter:card', content: "Contact Harrell’s | Corporate & Warehouse Information" });
    this.meta.updateTag({ property: 'Twitter:site', content: "Contact Harrell’s | Corporate & Warehouse Information" });
    this.meta.updateTag({ property: 'Twitter:title', content: "Contact Harrell’s | Corporate & Warehouse Information" });
    this.meta.updateTag({ property: 'Twitter:description', content: "Find contact details for Harrell’s corporate office, warehouses, HR, and credit department. Reach out for agronomic solutions and customer support." });
    // this.meta.updateTag({ property: 'Twitter:image', content: "twitter:image here - contacts" });

    this.dotComService.GetLocations();
  }


  ToggleExpand(warehouse: any) {
    if (this.warehouseToDisplay == warehouse.Id) {
      this.warehouseToDisplay = 0;
    } else {
      this.warehouseToDisplay = warehouse.Id;



      //map data
      this.options = {
        mapId: "DEMO_MAP_ID",
        center: { lat: parseFloat(warehouse.latitude), lng: parseFloat(warehouse.longitude) },
        zoom: 10,
      };
      //map pin data -- you can have multiple pins if you add more objects to the nzLocations array
      this.nzLocations = [
        { lat: parseFloat(warehouse.latitude), lng: parseFloat(warehouse.longitude) }
      ];
      //get the employee info to dislay the photos and hover displays name and title
      this.dotComService.GetEmployees('GetSiteServiceEmployees', warehouse.Id, 0).subscribe(data => {

           //filter all customer service peeps who are not supervisors or managers or customer service titles
        data = data.filter(x => x.Title.indexOf('Manager')> -1 || x.Title.indexOf('Supervisor')> -1 || x.Title.indexOf('Customer Service')> -1)

        warehouse.employees = data;
     

        //scroll to the top of the warehouse info section
        const anchor = document.getElementById(warehouse.name);
        anchor.scrollIntoView();

        for (let index = 0; index < warehouse.employees.length; index++) {
          const element = warehouse.employees[index];
          //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
          this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + element.Id + ".jpg", (exists) => {
            if (exists) {
              // Success code
              //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
              element.empPhoto = this.employeePhotosImagePaths + element.Id + ".jpg";
            } else {
              // Fail code
              this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + element.Id + ".png", (exists) => {
                if (exists) {
                  // Success code
                  element.empPhoto = this.employeePhotosImagePaths + element.Id + ".png";
                } else {
                  // Fail code - use default
                  element.empPhoto = this.baseImagePaths + "harrellsh.png"
                }
              })
            }
          });
        }
      });
    }
  }

  GetDirections(warehouse: any) {
    window.open("https://www.google.com/maps/dir//" + warehouse.address + ", " + warehouse.city + ", " + warehouse.state + " " + warehouse.zip, "_blank");
  }
  
  ChangeOpacity(id:string){
    document.getElementById(id).style.opacity = '.1';
    document.getElementById(id+'detail').style.display = 'block'
  }

  ChangeOpacityBack(id:string){
    document.getElementById(id).style.opacity = '1';
    document.getElementById(id+'detail').style.display = 'none'
  }


}
